module.exports = __webpack_public_path__ + "static/media/almaco_bg-3.a51bf220.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/almaco_bg-3.jpg
// module id = 315
// module chunks = 0